angular.module('smartorg.r6.acts.commonData').directive("commonData", ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            template: require('../../template/common-data.html'),
            scope: {
                smartorg: '=',
                menu: '='
            },
            link: function (scope) {
                scope.showAlert = function (type, title, message) {
                    scope.$emit('workbench:alert', {
                        type: type,
                        title: title,
                        message: message
                    });
                };
                scope.$on('command:COMMON_DATA', function (event, args) {
                    scope.actionMenuItem = args.actionMenuItem;
                    // Clear up variables.
                    scope.config = undefined;
                    scope.inputs = undefined;
                    scope.selectedInput = undefined;
                    scope.origSelectedInput = undefined;
                    scope.displayTab = undefined;
                    scope.dropdownList = [];
                    scope.reloadDropdown = true;
                    // Load page.
                    scope.nodeId = args.nodeId;
                    scope.loadCommonData(scope.nodeId);
                });
                scope.dropdownHandler = function () {
                    if (scope.$root.smartorgDirty) {
                        var discardChange = confirm("The unsaved data will be lost. Do you want to proceed?");
                        if (discardChange) {
                            scope.$root.smartorgDirty = false;
                        }
                        else {
                            scope.selectedInput = scope.origSelectedInput;
                            return;
                        }
                    }
                    scope.origSelectedInput = scope.selectedInput;
                    scope.displayInputTab();
                };
                /**
                 * Initial common data page.
                 *
                 * @param config {{}} Input from the api. Very complex
                 *     data structure.
                 */
                scope.displayCommonData = function (config) {
                    scope.config = config;
                    var _a = config.data, readOnly = _a.readOnly, _b = _a.inputScreenConfig.main, inputs = _b.inputs, nodeName = _b.nodeName;
                    scope.nodeName = nodeName;
                    scope.inputs = scope.separateTableFromInput(inputs);
                    scope.readOnly = readOnly;
                    if (!scope.selectedInput) {
                        scope.selectedInput = scope.dropdownList[0];
                    }
                    scope.origSelectedInput = scope.selectedInput;
                    $timeout(scope.displayInputTab);
                };
                /**
                 * Detemine displaying input screen or table input.
                 */
                scope.displayInputTab = function () {
                    if (scope.selectedInput.name == 'Single Variables') {
                        scope.displayTab = 'inputScreen';
                        scope.config.data.inputs = scope.inputs.nonTables;
                        scope.$broadcast('command:INPUT_SCREEN', {
                            config: scope.config,
                            actionMenuItem: scope.actionMenuItem,
                            commonData: true,
                            readOnly: scope.readOnly
                        });
                    }
                    else {
                        // Find table by key
                        var key = scope.selectedInput.key;
                        var index = -1;
                        for (var i = 0; i < scope.inputs.tables.length; i++) {
                            if (scope.inputs.tables[i][0].Key == key) {
                                index = i;
                            }
                        }
                        if (index > -1) {
                            scope.displayTab = 'tableInput';
                            var config = {
                                readOnly: scope.config.data.readOnly,
                                commonData: true,
                                data: {
                                    nodeID: scope.nodeId,
                                    inputs: scope.inputs.tables[index],
                                    tableDefn: scope.inputs.tables[index]
                                }
                            };
                            scope.$broadcast('command:TABLE_INPUT', {
                                config: config,
                                actionMenuItem: scope.actionMenuItem,
                                commonData: true,
                                nodeID: scope.nodeId,
                                readOnly: scope.readOnly
                            });
                        }
                        else {
                            scope.showAlert('danger', 'Failed to Load Data', 'Unknown option. Option not exists in data.');
                        }
                    }
                };
                /**
                 * Separate tables and non-tables.
                 *
                 * @param inputs {Array} Array of inputs from config. Will
                 *     be replaced by results of this function.
                 *
                 * @returns {{tables: Array, nonTables: Array}}
                 */
                scope.separateTableFromInput = function (inputs) {
                    /**
                     * tables: an array of array. Table data structure is
                     * array.
                     *
                     * @type {{tables: Array, nonTables: Array}}
                     */
                    var result = {
                        tables: [],
                        nonTables: []
                    };
                    if (scope.reloadDropdown) {
                        scope.dropdownList = [];
                    }
                    var singleVariableInserted = false; // Track if "Single Variables" has been inserted
                    // Iterate through inputs in JSON order
                    for (var i = 0; i < inputs.length; i++) {
                        if (inputs[i].Type === 'TABLE') {
                            result.tables.push([inputs[i]]);
                            if (scope.reloadDropdown) {
                                scope.dropdownList.push({
                                    name: 'Table Variable - ' + inputs[i].Display,
                                    key: inputs[i].Key
                                });
                            }
                        }
                        else {
                            result.nonTables.push(inputs[i]);
                            // Insert "Single Variables" at the first occurrence of a non-TABLE
                            if (!singleVariableInserted) {
                                scope.dropdownList.push({
                                    name: 'Single Variables',
                                    key: null
                                });
                                singleVariableInserted = true;
                            }
                        }
                    }
                    scope.reloadDropdown = false;
                    return result;
                };
                // ============================================
                // API Calls
                // ============================================
                /**
                 * Load all common data from API.
                 *
                 * @param nodeID {string} Tree node id.
                 */
                scope.loadCommonData = function (nodeID) {
                    scope.smartorg.sharedDataFor(nodeID).then(function (data) {
                        if (data) {
                            // display
                            scope.displayCommonData({ data: data });
                        }
                        else {
                            if (data) {
                                scope.showAlert('danger', 'Failed to Load Data', data['msg']);
                            }
                            else {
                                scope.errorPageMsg = data;
                            }
                        }
                    })["catch"](function (err) {
                        scope.showAlert('danger', 'Server Error ' + err.status, err.message);
                    });
                };
                /**
                 * Override a common input field.
                 *
                 * @param targetNodeId {string} Should be currently
                 *     selected node.
                 * @param sourceNodeId {string} Where the common data come
                 *     from, default is root node. If parent level is
                 *     overriding, should be closest parent node.
                 * @param inputKey {string} Input field key.
                 */
                scope.overrideInput = function (targetNodeId, sourceNodeId, inputKey) {
                    scope.smartorg.overrideInput(targetNodeId, sourceNodeId, inputKey).then(function (result) {
                        if (result.status) {
                            scope.loadCommonData(scope.nodeId);
                            if (result.valueChanged) {
                                scope.$emit('workbench:update_isDataValid', {
                                    nodeIdList: [targetNodeId],
                                    isDataValid: false
                                });
                            }
                        }
                    })["catch"](function (err) {
                        scope.showAlert("danger", "Server Error " + err.status, err.message);
                    });
                };
                /**
                 * Same as override, this is de-override. Cancel all
                 * override effect on current node.
                 *
                 * @param targetNodeId {string} Current selected node.
                 * @param inputKey {string} Input field.
                 */
                scope.deoverrideInput = function (targetNodeId, inputKey) {
                    scope.smartorg.deoverrideInput(targetNodeId, inputKey).then(function (result) {
                        if (result.status) {
                            scope.loadCommonData(scope.nodeId);
                            if (result.valueChanged) {
                                scope.$emit('workbench:update_isDataValid', {
                                    nodeIdList: [targetNodeId],
                                    isDataValid: false
                                });
                            }
                        }
                    })["catch"](function (err) {
                        scope.showAlert("danger", "Server Error " + err.status, err.message);
                    });
                };
                scope.successSaveCallback = function () {
                    scope.loadCommonData(scope.nodeId);
                };
            }
        };
    }]);
//# sourceMappingURL=common-data-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/common-data/app/js/plumbing/common-data-directive.js